document.addEventListener('DOMContentLoaded', () => {
    const item = document.querySelectorAll('li.grid__item');

    item.forEach((element) => {
        const materialEl = element.querySelector('.material-value');
        const productMaterial = element.querySelector('.product__material');
        const header = element.querySelectorAll('.hidden-description tbody tr')[0];
        const valueRow = element.querySelectorAll('.hidden-description tbody tr')[1];
        let selectedIndex;
        
        if (header && productMaterial) {
            const cells = Array.from(header.querySelectorAll('td'));
            const materialIndex = cells.findIndex(el =>
            el.textContent.trim().toUpperCase() == 'MATERIAL'
            );

            if (materialIndex < 0) {
                productMaterial.remove();
                return;
            }
            selectedIndex = materialIndex;
        }

        if (valueRow && selectedIndex >= 0) {
           const cells = Array.from(valueRow.querySelectorAll('td'));
           const value = cells[selectedIndex]
           materialEl.textContent = value.textContent;
        }
        
    })

    // Setup mega menu position for CSS
    // initial run

    
    const root = document.documentElement;
    const megaMenu = document.querySelector('.desktop-megamenu');
    updateMegaPosition();

    function updateMegaPosition() {
        if (!megaMenu) return;

        const rect = megaMenu.getBoundingClientRect();
        root.style.setProperty('--style-6-mega-position', `${rect.left}px`);
    }


    
    window.addEventListener('resize', updateMegaPosition);
});

globalThis.noImage = 'https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif';





